module.exports = [
    '$cookies', 
    '$location',
    '$q', 
    '$translate',
    '$window', 
    'config', 
    'dataContext', 
    'language', 
    preferenceService
];

function preferenceService(
    $cookies, 
    $location, 
    $q, 
    $translate,
    $window, 
    config, 
    dataContext, 
    language
) {

    var service = {
        preferences: [],
        add: addPreference,
        get: getPreference,
        getAny: getAnyPreference,
        getCategory: getPreferencesByCategory,
        init: reload,
        initialized: false,
        reload: reload,
        remove: removePreference,
        replace: replacePreference,
        update: updatePreference,
        
        saveCountryPreference: saveCountryPreference,
        clearCountryPreference: clearCountryPreference,
        saveFranceAreaOfApplicationPreference: saveFranceAreaOfApplicationPreference,
        setLanguage: setLanguage,
        setReferenceCountry: setReferenceCountry,

        addRecentCode: addRecentCode
    };

    function replacePreference(preference) {
        var existingPreference = getPreference(preference.name, preference.category);
        if (existingPreference) {
            preference.id = existingPreference.id;
            return updatePreference(preference);
        }
        else {
            return addPreference(preference);
        }
    }

    function addPreference(preference) {
        if (preference === null) {
            return $q.when(null);
        }

        var obj = toModel(preference);
        return dataContext.post(config.apiHosts.generic + '/preference', obj, true)
            .then(function (data) {
                service.preferences.push(fromModel(data));
                return fromModel(data);
            });
    }

    function getPreference(name, category) {
        var result = _.find(service.preferences, function (preference) {
            if (category !== undefined) {
                return preference.name === name && preference.category === category;
            }
            return preference.name === name;
        });

        if (result === undefined)
            return null;

        return result;
    }

    function getAnyPreference(name) {
        var result = _.filter(service.preferences, function (preference) {
            return preference.name === name;
        });

        if (result === undefined || result === null)
            return [];
        return result;
    }

    function getPreferencesByCategory(name) {
        if (!name) {
            return $q.when([]);
        }

        if (service.initialized === true) {
            return $q.when(filterPreferencesByCategory(service.preferences, name));
        }

        return dataContext.get(config.apiHosts.generic + '/preference')
            .then(function (data) {
                data = _.map(data, fromModel);
                return filterPreferencesByCategory(data, name);
            });
    }

    function filterPreferencesByCategory(preferences, name) {
        if (!preferences || !name) {
            return [];
        }

        var normalizedName = name.toLowerCase();

        return _.filter(preferences, function (preference) {
            return preference.category &&
                preference.category.toLowerCase() === normalizedName;
        });
    }

    function fromModel(item) {
        var result = {
            id: item.id,
            category: item.category,
            lastUpdate: item.lastUpdate,
            name: item.name,
            sortOrder: item.sortOrder,
            valueType: item.valueType
        };

        switch (item.valueType) {
            case 'booleanValue':
                result[item.name] = item.booleanValue;
                result.value = item.booleanValue;
                break;
            case 'dateTimeValue':
                result[item.name] = item.dateTimeValue;
                result.value = item.dateTimeValue;
                break;
            case 'numericValue':
                result[item.name] = item.numericValue;
                result.value = item.numericValue;
                break;
            default:
                result[item.name] = item.stringValue;
                result.value = item.stringValue;
                break;
        }

        return result;
    }

    function reload() {
        return dataContext.get(config.apiHosts.generic + '/preference')
            .then(function (data) {
                data = _.map(data, fromModel);

                service.preferences = data;
                service.initialized = true;

                return data;
            })
            .catch(function (error) {
                if (error && error.status === 401) {
                    $cookies.remove('authToken');
                    $window.location.reload();
                }

                return $q.reject(error);
            });
    }

    function removePreference(preference) {
        if (preference === null || preference.id === undefined || preference.id === null)
            return;

        var obj = toModel(preference);
        service.preferences.splice(_.findIndex(service.preferences, function (prefToFind) { return prefToFind.id === obj.id; }), 1);
        return dataContext.del(config.apiHosts.generic + '/preference/' + preference.id);
    }

    function toModel(preference) {
        var originalPreference = null;
        if (preference.id !== undefined && preference.id !== null)
            originalPreference = _.find(service.preferences, function (prefToFind) { return prefToFind.id === preference.id; });

        var obj = {
            id: preference.id !== undefined && preference.id !== null ? preference.id : -1,
            lastUpdate: new Date(),
            name: preference.name !== undefined && preference.name !== null ? preference.name : (originalPreference !== undefined && originalPreference !== null && originalPreference.name !== undefined && originalPreference.name !== null ? originalPreference.name : null),
            category: preference.category !== undefined && preference.category !== null ? preference.category : (originalPreference !== undefined && originalPreference !== null && originalPreference.category !== undefined && originalPreference.category !== null ? originalPreference.category : null),
            sortOrder: preference.sortOrder !== undefined && preference.sortOrder !== null ? preference.sortOrder : (originalPreference !== undefined && originalPreference !== null && originalPreference.sortOrder !== undefined && originalPreference.sortOrder !== null ? originalPreference.sortOrder : null),
            valueType: preference.valueType !== undefined && preference.valueType !== null ? preference.valueType : (originalPreference !== undefined && originalPreference !== null && originalPreference.valueType !== undefined && originalPreference.valueType !== null ? originalPreference.valueType : null)
        };

        if (obj.name === null)
            return null;
        if (obj.valueType === null)
            obj.valueType = 'stringValue';

        switch (obj.valueType) {
            case 'booleanValue':
                obj.booleanValue = preference.value;
                break;
            case 'dateTimeValue':
                obj.dateTimeValue = preference.value;
                break;
            case 'numericValue':
                obj.numericValue = preference.value;
                break;
            default:
                obj.stringValue = preference.value;
                break;
        }

        return obj;
    }

    function updatePreference(preference) {
        if (preference === null) {
            return $q.when(null);
        }

        var obj = toModel(preference);

        return dataContext.put(config.apiHosts.generic + '/preference/' + obj.id, obj, true)
            .then(function () {
                var index = _.findIndex(service.preferences, function (prefToFind) {
                    return prefToFind.id === obj.id;
                });

                if (index > -1) {
                    service.preferences[index] = fromModel(obj);
                }

                return fromModel(obj);
            });
    }

    function setLanguage(lang) {
        return language.set(lang).then(function() {
            var currentPref = service.get('language', 'website');
            if (currentPref) {
                currentPref.value = lang;
                return service.update(currentPref);
            }
            else {
                return service.add({
                    category: 'website',
                    name: 'language',
                    valueType: 'stringValue',
                    value: lang
                });
            }
        });

    }

    function setReferenceCountry(referenceCountry) {
        var currentPref = service.get('referenceCountry', 'user_preferences');
        if (referenceCountry === 'GB') {
            setLanguage('en');
            $location.search('includeCustomsRulings', null).replace();
        }
        else if (referenceCountry === 'US') {
            setLanguage('en');
            $location.search('includeBtis', null).replace();
            $location.search('includeClassificationRegulations', null).replace();
            $location.search('includeCaseLaw', null).replace();
        }
        else {
            $location.search('includeBtis', null).replace();
        }
        if (currentPref) {
            currentPref.value = referenceCountry;
            return service.update(currentPref);
        }
        else {
            return service.add({
                category: 'search',
                name: 'referenceCountry',
                valueType: 'stringValue',
                value: referenceCountry
            });
        }
    }

    function saveCountryPreference(country) {
        service.add({ name: 'searchCountry', category: 'search', value: country.code + ',' + country.name });
    }

    function saveFranceAreaOfApplicationPreference(areaOfApplication) {
        if (areaOfApplication) {
            service.add({ name: 'franceAreaOfApplication', category: 'measuresFilter', value: areaOfApplication });
        }
        else {
            try {
                var pref = service.get('franceAreaOfApplication', 'measuresFilter');
                if (pref) {
                    service.remove(pref);
                }
            } catch (err) { }
        }
    }

    function clearCountryPreference() {
        try {
            var pref = service.get('searchCountry', 'search');
            if (pref) {
                service.remove(pref);
            }
        } catch (err) { }
    }

    function addRecentCode(commodityCode, movement) {
        service.add({
            name: commodityCode + '_' + movement,
            category: 'recent_codes',
            value: 'goodsnom=' + commodityCode + '&type=' + movement,
            valueType: 'stringValue'
        });
    }

    return service;
}
